import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { AccountingApi } from '_api';
import { FIELD_KEYS } from '_constants/forms';
import { handleError, handleResponse } from '_helpers/api';

export const getUpcomingDates = createAsyncThunk(
  'upcomingDates/getUpcomingDates',
  async function ({ codes = [] }, { rejectWithValue }) {
    try {
      const allResponses = await Promise.all(codes?.map((code) => AccountingApi.getUpcomingDates({ code })));
      const allData = handleResponse(allResponses);
      return allData?.reduce((res, data) => [...res, ...data], []);
    } catch (error) {
      const processedError = handleError(error);
      return rejectWithValue(processedError);
    }
  }
);

const initialParams = {
  [FIELD_KEYS.page]: 1,
  [FIELD_KEYS.count]: 3,
};

const upcomingDatesSlice = createSlice({
  name: 'upcomingDates',
  initialState: {
    params: initialParams,
    data: [],
    error: null,
    loading: false,
    fetchCounter: 0,
  },
  reducers: {
    refreshParams(state, action) {
      state.params = {
        ...state.params,
        ...action.payload,
      };
    },
    resetParams(state) {
      state.params = {
        ...state.params,
        ...initialParams,
      };
    },
    resetData(state) {
      state.data = [];
    },
    resetError(state) {
      state.error = null;
    },
    resetFetchCounter(state) {
      state.fetchCounter = 0;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUpcomingDates.pending, (state) => {
        state.error = null;
        state.loading = true;
      })
      .addCase(getUpcomingDates.fulfilled, (state, action) => {
        state.data = action.payload;
        state.fetchCounter += 1;
        state.loading = false;
      })
      .addCase(getUpcomingDates.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export const { refreshParams, resetParams, resetData, resetError, resetFetchCounter } = upcomingDatesSlice.actions;

export default upcomingDatesSlice.reducer;
